// 45 min sessions need a 15 min start-time grid; every other duration stays on 30 min.
export const get_time_interval_for_duration = (duration) => (Number(duration) === 45 ? 15 : 30);

// Empty, null or junk zones make Intl throw and crash the render, so they give ''.
export const formatTimeInZone = (date, ianaTimeZone) => {
  if (!ianaTimeZone) return '';
  try {
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'short',
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
      timeZone: ianaTimeZone,
      timeZoneName: 'long'
    })
      .format(date)
      .replace(',', '');
  } catch (e) {
    return '';
  }
};
